export default __webpack_public_path__ + "static/media/gatheringOffers.17d70328.svg";